import React, { useRef } from 'react';
import cn from 'classnames';
import style from './index.module.scss';
import Player from 'components/player';

interface IProps {
  decorate: string;
  title: string;
  descArr: string[];
  caseImg: {
    src: string;
    videoSrc?: string;
  }[];
  className?: string;
}

const playBtn = '/v2/images/pc-play.png';
const Introduce = (props: IProps) => {
  const { decorate, title, descArr, caseImg, className } = props;
  const playerRef = useRef<any>();
  const videoPlay = (url: string) => {
    playerRef.current?.play(url);
  };
  return (
    <section className={cn(style.banner, className)}>
      <div className={style.content}>
        <img src={`${decorate}`} className={style.decorate} alt="" />
        <p className={style.title}>{title}</p>
        {descArr.map((item: string) => {
          return <p key={item}>{item}</p>;
        })}
        <div className={'video-content'}>
          {caseImg.map((item: { src: string; videoSrc?: string }) => {
            if (item.videoSrc) {
              return (
                <div key={item.src} className={'video-item'}>
                  <div onClick={() => videoPlay(item.videoSrc as string)}>
                    <img src={item.src} alt="" />
                    <img src={playBtn} className={'play-btn'} alt="" />
                  </div>
                </div>
              );
            }
            return (
              <div key={item.src} className={'video-item'}>
                <img src={item.src} alt="" />
              </div>
            );
          })}
        </div>
      </div>
      <Player ref={playerRef} />
    </section>
  );
};

interface ILanding {
  bg: string;
  title: string;
  desc: string;
  descColor?: string;
}

export const Landing = ({ bg, title, desc, descColor }: ILanding) => {
  return (
    <section className={style.landing} style={{ backgroundImage: `url(${bg})` }}>
      <p className={style.title}>{title}</p>
      <p className={style.desc} style={{ color: descColor ? descColor : '#fff' }} dangerouslySetInnerHTML={{ __html: desc.replace(/\n/g, '<br/>') }}></p>
    </section>
  );
};

export const IntroduceMobile = ({ list }: { list: { icon: string; title: string; desc: string }[] }) => {
  return (
    <div className={style.introduce}>
      {list.map(item => {
        return (
          <div key={item.title} className={style.item}>
            <img src={item.icon} alt="" className={style['item-icon']} />
            <p className={style['item-title']}>{item.title}</p>
            <p className={style['item-desc']} dangerouslySetInnerHTML={{ __html: item.desc.replace(/\n/g, '<br/>') }}></p>
          </div>
        );
      })}
    </div>
  );
};

export default Introduce;
